<template>
  <v-alert
    v-if="isAdmin"
    icon="mdi-currency-usd"
    color="grey lighten-3"
    class="mb-0 mr-5"
  >
    <div class="d-flex justify-space-between">
      <h4 class="mt-0 mb-1">
        {{ $t('quote.amount.title') }}
      </h4>

      <v-tooltip v-if="transferId" top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            :href="`/transfer/${transferId}`"
            target="_blank"
            class="grey lighten-3"
            v-bind="attrs"
            v-on="on"
            small
            icon
          >
            <v-icon color="primary" small>
              mdi-open-in-new
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('quote.amount.showTransfer') }}</span>
      </v-tooltip>
    </div>
   
    <div class="d-flex">
      <div class="mr-10">
        <p class="caption mb-0 grey--text">
          {{ $t('quote.amount.itemsValues') }}
        </p>
        <span class="body-2">
          {{ vendorNetValue ? formatCurrency(vendorNetValue) : '---' }}
        </span>
      </div>
      <div class="mr-10">
        <p class="caption mb-0 grey--text">
          {{ $t('quote.amount.splitValues') }}
        </p>
        <span class="body-2">
          {{ splitValue ? formatCurrency(splitValue) : '---' }}
        </span>
      </div>
    </div>
  </v-alert>
</template>

<script>
import { mapGetters } from 'vuex'
import { catalogMonetary } from '@/util/catalog'

export default {
  name: 'AppointmentOtherValues',

  props: {
    transferId: {
      type: String,
    },
  },

  computed: {
    ...mapGetters(['serviceReport']),

    quote() {
      return this.serviceReport?.quotes[0]
    },

    vendorNetValue() {
      return this.quote?.vendor_net_value
    },

    splitValue() {
      return this.quote?.split_value
    },

    isAdmin() {
      return this.$route.path.includes('admin')
    }
  },

  data() {
    return {
      formatCurrency: catalogMonetary,
    }
  }
}
</script>
